import NewsApp from 'hb-react/frontoffice/apps/News/startup/NewsAppClient';
import { useTopicContext } from 'hb-react/frontoffice/contexts/TopicContext';
import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';
import { createNewsAppConfig } from 'hb-react/shared/apps/Topics/containers/TopicNewsContainer/utils';

const TopicNewsContainer = () => {
  const topicContext = useTopicContext();
  const { currentUser } = useDefaultAppContexts();
  const { topicId } = topicContext;

  const config = createNewsAppConfig({ topicId, currentUser, topicContext });

  return <NewsApp config={config} topic={{ id: topicId }} />;
};

export default TopicNewsContainer;
